module.exports = __webpack_public_path__ + "static/media/card-game-bg.3a020588.png";